import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ok",
  "use": "ok-usage",
  "viewBox": "0 0 10.594 8.063",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10.594 8.063\" id=\"ok\">\n  <path fill-rule=\"evenodd\" d=\"M451.51,154.939l-6.071,6.071a1,1,0,0,1-1.414,0l-2.536-2.535a1,1,0,0,1,1.414-1.415l1.829,1.829,5.364-5.364a1,1,0,0,1,1.414,1.414\" transform=\"translate(-441.219 -153.25)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/ok.svg
// module id = null
// module chunks = 